/**
 * Dynamically determine API base URL based on current host
 * This function returns the base URL without the /api suffix
 */
export const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname;

  // Entwicklung: localhost verwendet direkten Backend-Zugriff
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }

  // Produktion: Alle Zugriffe laufen über NGINX Proxy
  // Verwendet automatisch das gleiche Protokoll (http/https) wie die Seite
  return `${window.location.protocol}//${hostname}`;
};

/**
 * Get full API URL with /api prefix
 */
export const getApiUrl = (): string => {
  return `${getApiBaseUrl()}/api`;
};

/**
 * Get OnlyOffice Document Server URL
 * In development: direct access to local server
 * In production: must use HTTPS-enabled proxy
 */
export const getOnlyOfficeServerUrl = (): string => {
  const hostname = window.location.hostname;

  // Entwicklung: lokaler OnlyOffice Server
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return process.env.REACT_APP_ONLYOFFICE_SERVER_URL || 'http://localhost:80';
  }

  // Produktion: OnlyOffice über HTTPS Proxy
  // Anpassen wenn OnlyOffice über eigene Subdomain läuft
  // Beispiel: https://onlyoffice.wendelbuck.dyndns.org
  const onlyOfficeHost = process.env.REACT_APP_ONLYOFFICE_SERVER_URL;
  if (onlyOfficeHost) {
    return onlyOfficeHost;
  }

  // Fallback: OnlyOffice über /onlyoffice Pfad (erfordert NGINX Config)
  return `${window.location.protocol}//${hostname}`;
};
